<template>
  <div
    class="hamburger-container"
    :class="[{ 'is-active': isActive }]"
    @click="toggleClick"
  >
    <el-icon><ExpandElementIcon /></el-icon>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import useResize from '@/hooks/useResize'

export default defineComponent({
  name: 'Hamburger',
  props: {
    isActive: {
      type: Boolean,
      default: false
    }
  },
  setup(props, context) {
    const toggleClick = function () {
      context.emit('toggle')
    }
    const { isDesktop } = useResize()

    return { toggleClick, isDesktop }
  }
})
</script>

<style lang="scss" scoped>
.svg-icon {
  vertical-align: middle;
}

.is-active {
  transform: rotate(180deg);
}

.hamburger-container {
  display: flex;
  align-items: center;
  line-height: 46px;
  height: 100%;
  padding: 0 15px;
  cursor: pointer;
  transition: background 0.3s;
  -webkit-tap-highlight-color: transparent;

  &:hover {
    background: rgba(0, 0, 0, 0.025);
  }
}
</style>
